// extracted by mini-css-extract-plugin
export var closeButton = "_dr-1";
export var closeX = "_dr-3";
export var container = "_dr-0";
export var image = "_dr-2";